<div id="bottom-navigations">
  <div class="bottom-navigations-background d-flex container p-0">
    <div class="link w-50">
      <a
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLinkActive]="['active']"
        routerLink="/feed"
      >
        <span class="nav-icon"><i class="napp-logo napp-logo-brand"></i></span>
        <span class="nav-text">{{ 'feed.navLabel' | translate }}</span>
      </a>
    </div>
    @if (isLoggedIn && hasAnySubscriptions) {
      <div class="link w-50">
        <a
          [queryParams]="{ feedtype: 'subscribed' }"
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLinkActive]="['active']"
          routerLink="/feed"
        >
          <span class="nav-icon"><i class="fas fa-tags va-middle"></i></span>
          <span class="nav-text">{{ 'feed.myFeed' | translate }}</span>
        </a>
      </div>
    }
    @if (isLoggedIn && !hasAnySubscriptions) {
      <div class="link w-50">
        <a
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLinkActive]="['active']"
          routerLink="/feed/subscriptions"
        >
          <span class="nav-icon"><i class="fas fa-tags va-middle"></i></span>
          <span class="nav-text">{{ 'feed.myFeed' | translate }}</span>
        </a>
      </div>
    }
    @if (!isLoggedIn) {
      <div class="link w-50">
        <a routerLink="/feed/subscriptions">
          <span class="nav-icon"><i class="fas fa-tags va-middle"></i></span>
          <span class="nav-text">{{ 'feed.myFeed' | translate }}</span>
        </a>
      </div>
    }
  </div>
</div>
